// ============================================================================
// TENANT USERS ENDPOINTS - Digital Approval System
// ============================================================================
// Tenant-scoped user management endpoints. Used by the admin password-reset
// feature to operate on ANY user belonging to the current tenant — not only
// DAS-registered users.

import { buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Tenant User API Endpoints
 * All endpoints are tenant-scoped: /tenants/{tenantId}/users
 */
export const tenantUserEndpoints = {
  /**
   * Get all users belonging to a tenant (paginated)
   * GET /tenants/:tenantId/users
   */
  list: (tenantId: ID) =>
    buildEndpointWithParams('/tenants/:tenantId/users', { tenantId }),

  /**
   * Admin reset of a tenant user's password
   * PUT /tenants/:tenantId/users/:id/reset-password
   */
  resetPassword: (tenantId: ID, id: ID) =>
    buildEndpointWithParams('/tenants/:tenantId/users/:id/reset-password', {
      tenantId,
      id,
    }),
} as const;

export default tenantUserEndpoints;
